module.exports = __webpack_public_path__ + "static/media/alpha_19.2e4c9b2c.png";